<section id="features">
  <div class="container">
    <div class="text-center" appReveal>
      <div class="sec-label">Características</div>
      <h2 class="sec-title" style="max-width:700px;margin:0 auto 1rem">Todo lo que incluye la plataforma</h2>
      <p class="sec-sub mx-auto">Cada funcionalidad disponible en CradleResident, organizada por área.</p>
    </div>
    <div class="row g-4 mt-4" appReveal>
      <div class="col-md-4">
        <div class="af-card h-100">
          <div class="af-header af-pay">
            <span class="af-emoji">💳</span>
            <h3>Pagos y administración</h3>
          </div>
          <ul class="af-list">
            <li>💳 Control de pagos de mantenimiento</li>
            <li>📂 Registro de gastos con archivo digital</li>
            <li>🧾 Envío y recepción de comprobantes de pago</li>
            <li>📜 Estado de cuenta del residente</li>
            <li>☁️ Almacenamiento ilimitado de comprobantes</li>
            <li>🎾 Administración de amenidades</li>
            <li>📕 Manejo de reportes</li>
            <li>🧑‍💻 Gestión de usuarios</li>
            <li>📦 Sistema de gestión de paquetería</li>
            <li>🔐 Consulta histórica de accesos</li>
          </ul>
        </div>
      </div>
      <div class="col-md-4">
        <div class="af-card h-100">
          <div class="af-header af-sec">
            <span class="af-emoji">🛡️</span>
            <h3>Seguridad y control de acceso</h3>
          </div>
          <ul class="af-list">
            <li>🚪 Control de visitas mediante código QR</li>
            <li>🚪 Códigos QR para visitas recurrentes con horarios</li>
            <li>📸 Bitácora de visitas con fotografía</li>
            <li>📩 Notificación push de entrada y salida de visitas</li>
            <li>🆘 Botón de pánico con aviso a vecinos y guardias</li>
            <li>🚙 Automatización de accesos para visitas</li>
            <li>🚙 Automatización de accesos para residentes</li>
            <li>📱 Apertura remota desde la aplicación</li>
            <li>📡 Lectores QR, RFID y UHF</li>
            <li>🚦 Panel de control para barreras y plumas</li>
            <li>📷 Conexión con cámaras IP</li>
          </ul>
        </div>
      </div>
      <div class="col-md-4">
        <div class="af-card h-100">
          <div class="af-header af-comm">
            <span class="af-emoji">🗣️</span>
            <h3>Comunicación y comunidad</h3>
          </div>
          <ul class="af-list">
            <li>💬 Chat con vigilancia o guardia virtual</li>
            <li>📘 Publicación de reglamento para residentes y vigilantes</li>
            <li>📩 Notificación de entrada de servicios públicos</li>
            <li>📊 Encuestas en línea</li>
            <li>🗓️ Reservación de amenidades</li>
            <li>📞 Directorio telefónico de emergencias</li>
            <li>📝 Publicación de anuncios generales</li>
            <li>🥇 Publicación de logros de la administración</li>
            <li>📈 Registro de reportes</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
